export default function setDataLocal(item,Data) {
    if(item == false) {
        window.localStorage.setItem('list_item',JSON.stringify(Data));
        return;
    }
    Data.push(item);
    window.localStorage.setItem('list_item',JSON.stringify(Data));
}
